import React from 'react'
import {Box, Flex, Skeleton as ChakraSkeleton, SkeletonText} from '@chakra-ui/react'

const Skeleton = () => {
    return (
        <Flex flexDir="column" w="100%">
            <Flex w="100%" h={{base: '320px', md: '256px', lg: '500px'}} position="relative">
                <ChakraSkeleton height="100%" width="100%" borderRadius="md" />

                {/* Skeleton for Text Content (Desktop) */}
                <Box
                    display={{base: 'none', md: 'none', lg: 'flex'}}
                    width="100%"
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                    alignItems="center"
                    justifyContent="flex-start"
                    padding="4"
                >
                    <Flex layerStyle="page" direction="column" width="70%" textAlign="left">
                        <ChakraSkeleton height="24px" width="80%" mb="4" />
                        <SkeletonText mt="4" noOfLines={3} spacing="4" skeletonHeight="16px" />
                        <ChakraSkeleton height="40px" width="213px" mt="6" />
                    </Flex>
                </Box>
            </Flex>

            {/* Skeleton for Text Content (Mobile) */}
            <Box display={{base: 'flex', md: 'flex', lg: 'none'}} padding="4" width="100%">
                <Flex direction="column" width="100%" textAlign={'center'}>
                    <ChakraSkeleton height="24px" width="80%" mb="4" />
                    <SkeletonText mt="4" noOfLines={3} spacing="4" skeletonHeight="16px" />
                    <ChakraSkeleton height="40px" width="213px" mt="6" textAlign="center" />
                </Flex>
            </Box>
        </Flex>
    )
}

export default Skeleton
